/** Traductions modal confirmation commande (FR / AR) */
export const orderConfirmationModalFr = {
  dataErrorTitle: 'Erreur de données',
  dataErrorMessage: 'Veuillez vous assurer que toutes les quantités reçues et les prix sont valides',
  quantityErrorTitle: 'Erreur de quantité',
  quantityErrorMessage: 'Il doit y avoir au moins une quantité reçue supérieure à zéro',
  confirmCompleteArrival: 'Confirmer Arrivée Commande Complète',
  statusPending: 'En attente',
  statusConfirmed: 'Confirmée',
  statusInTransit: 'En transit',
  statusArrived: 'Arrivée',
  statusQualityCheck: 'Contrôle Qualité',
  statusApproved: 'Approuvée',
  statusDelivered: 'Livrée',
  statusCancelled: 'Annulée',
  statusUnknown: 'Inconnu',
  title: 'Confirmer Réception Commande',
  tabConfirmation: 'Confirmation',
  tabTracking: 'Suivi Commande',
  orderStatusSection: 'Statut de la Commande',
  expectedDeliveryDate: 'Date de livraison prévue',
  overdue: 'En retard',
  trackingHistory: 'Historique de Suivi',
  orderNumber: 'N° Commande',
  supplier: 'Fournisseur',
  orderDate: 'Date Commande',
  expectedDelivery: 'Livraison Prévue',
  actualDeliveryDate: 'Date de Livraison Réelle*',
  confirmReceivedProducts: 'Confirmer Produits Reçus',
  colProduct: 'Produit',
  colQtyOrdered: 'Qté Commandée',
  colQtyReceived: 'Qté Reçue',
  colPurchasePrice: 'Prix d\'Achat',
  colTotal: 'Total',
  discrepancyWarningTitle: 'Attention: Écarts de Quantités',
  discrepancyWarningText: '{{count}} produit(s) avec des quantités différentes de celles commandées. Veuillez vérifier les quantités avant confirmation.',
  extraExpenses: 'Dépenses Supplémentaires',
  customs: 'Douane (Zoll)',
  transport: 'Transport',
  totalProducts: 'Total Produits:',
  totalCustoms: 'Douane:',
  totalTransport: 'Transport:',
  grandTotal: 'Total Général:',
  cancelOrder: 'Annuler Commande',
  close: 'Fermer',
  confirmAndCreatePurchase: 'Confirmer Réception et Créer Achat',
  cancelConfirmTitle: 'Confirmer l\'annulation',
  cancelConfirmMessage: 'Êtes-vous sûr de vouloir annuler cette commande ? Cette action ne peut pas être annulée.',
  cancelDismiss: 'Annuler',
  cancelConfirm: 'Confirmer l\'annulation',
  supplierFallback: 'Fournisseur {{id}}',
  productUnknown: 'Produit inconnu'
};

export const orderConfirmationModalAr = {
  dataErrorTitle: 'خطأ في البيانات',
  dataErrorMessage: 'يرجى التأكد من أن جميع الكميات المستلمة والأسعار صحيحة',
  quantityErrorTitle: 'خطأ في الكمية',
  quantityErrorMessage: 'يجب أن تكون هناك كمية مستلمة واحدة على الأقل أكبر من صفر',
  confirmCompleteArrival: 'تأكيد وصول الطلب الكامل',
  statusPending: 'في الانتظار',
  statusConfirmed: 'تم التأكيد',
  statusInTransit: 'في الطريق',
  statusArrived: 'وصلت',
  statusQualityCheck: 'فحص الجودة',
  statusApproved: 'تمت الموافقة',
  statusDelivered: 'تم التسليم',
  statusCancelled: 'ملغاة',
  statusUnknown: 'غير معروف',
  title: 'تأكيد استلام الطلب',
  tabConfirmation: 'تأكيد الاستلام',
  tabTracking: 'تتبع الطلب',
  orderStatusSection: 'حالة الطلب',
  expectedDeliveryDate: 'تاريخ التسليم المتوقع',
  overdue: 'متأخر',
  trackingHistory: 'سجل التتبع',
  orderNumber: 'رقم الطلب',
  supplier: 'المورد',
  orderDate: 'تاريخ الطلب',
  expectedDelivery: 'التسليم المتوقع',
  actualDeliveryDate: 'تاريخ التسليم الفعلي*',
  confirmReceivedProducts: 'تأكيد المنتجات المستلمة',
  colProduct: 'المنتج',
  colQtyOrdered: 'الكمية المطلوبة',
  colQtyReceived: 'الكمية المستلمة',
  colPurchasePrice: 'سعر الشراء',
  colTotal: 'الإجمالي',
  discrepancyWarningTitle: 'تحذير: اختلافات في الكميات',
  discrepancyWarningText: 'تم العثور على {{count}} منتج(ات) بكميات مختلفة عن المطلوب. يرجى التأكد من الكميات قبل التأكيد.',
  extraExpenses: 'مصاريف إضافية',
  customs: 'الجمارك (Zoll)',
  transport: 'النقل (Transport)',
  totalProducts: 'إجمالي المنتجات:',
  totalCustoms: 'الجمارك:',
  totalTransport: 'النقل:',
  grandTotal: 'الإجمالي الكلي:',
  cancelOrder: 'إلغاء الطلب',
  close: 'إغلاق',
  confirmAndCreatePurchase: 'تأكيد الاستلام وإنشاء الشراء',
  cancelConfirmTitle: 'تأكيد الإلغاء',
  cancelConfirmMessage: 'هل أنت متأكد من أنك تريد إلغاء هذا الطلب؟ لا يمكن التراجع عن هذا الإجراء.',
  cancelDismiss: 'إلغاء',
  cancelConfirm: 'تأكيد الإلغاء',
  supplierFallback: 'مورد {{id}}',
  productUnknown: 'منتج غير معروف'
};
